var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('HeadNav'),_c('LeftMenu'),_c('Subject'),_c('div',{class:'rightContainer ' + (_vm.isCollapse ? 'spread' : '')},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }